<footer class="text-white py-4">
	<div class="container">
		<div class="row align-items-center">
			<div class="col-md-6 text-md-start text-center mb-3 mb-md-0">
				<!-- <p class="font-size-20">Subscribe to get our Newsletter</p> -->
				<!-- <form class="d-flex justify-content-md-start justify-content-center">
					<input
                        [formControl]="email"
						type="email"
						class="form-control w-50"
						placeholder="Your Email"
					/>
					<button class="btn btn-light ms-2 font-size-20 " (click)="subscribe()">Subscribe</button>
				</form> -->
				<p>Esagon Consulting</p>
				<p>Torino TO IT</p>
				<p>
					Developed by
					<a
						href="https://www.pcmitaly.it/ai"
						title="https://www.pcmitaly.it/ai"
						>PCM Srl</a
					>
				</p>
			</div>
			<div class="col-md-6 text-md-start text-center mb-3 mb-md-0">
				<p>P.I. 12497820014</p>
				<p>C.F. 12497820014</p>
				<p>info.esacons&#64;gmail.com</p>
				<div class="col-md-4 d-flex">
					<div style="margin-right: 10px">
						<a
							href="https://www.iubenda.com/privacy-policy/45613051"
							class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe"
							title="Privacy Policy"
							>Privacy Policy</a
						>
					</div>
					<div style="margin-right: 10px">
						<a
							href="https://www.iubenda.com/privacy-policy/45613051/cookie-policy"
							class="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe"
							title="Cookie Policy"
							>Cookie Policy</a
						>
					</div>
					<div>
						<a
							href="https://www.iubenda.com/termini-e-condizioni/45613051"
							class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe"
							title="Termini e Condizioni"
							>Termini e Condizioni</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
